import { render } from "./AppProductCard.vue?vue&type=template&id=bd5d0a12"
import script from "./AppProductCard.vue?vue&type=script&lang=js"
export * from "./AppProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__